module.exports = __webpack_public_path__ + "static/media/check.d7edc9c0.svg";